import React, { Component } from 'react';

import {
  TRIM_BOUND_DEACTIVATE_TIMEOUT,
  TRIM_BOUND_LOWER,
  TRIM_BOUND_UPPER,
} from 'constants/trimming';
import { secondsToVideoTS } from 'utilities/time';

import './styles.less';

export const LEFT_HALF = 'left';
export const RIGHT_HALF = 'right';

const MOUSE_PRESS_KICK_IN_TIME = 300;

const MOUSE_PRESS_TIMEOUT = 50;

const PILL_TIME_STEP = 100;

class TrimPill extends Component {
  deactivateBoundTimeout = null;
  mousePressKickInTimeout = null;
  mousePressTimeout = null;

  state = {
    mouse_pressed: false,
  };

  render() {
    const { active, time } = this.props;

    const activeClass = active ? 'active' : '';
    const videoTimestamp = secondsToVideoTS(Math.floor(time / 1000));

    const milliseconds = String(Math.floor((time % 1000) / 100));
    const timeString = `${videoTimestamp}.${milliseconds}`;

    return (
      <div
        className={`trim-pill ${activeClass}`}
        onClick={this.activateTrimBound}
      >
        <div className="time-display">{timeString}</div>
        <div className="arrows">
          <span
            className="up arrow"
            onMouseDown={this.incrementTime}
            onMouseUp={this.clearMousePressTimeout}
          />
          <span
            className="down arrow"
            onMouseDown={this.decrementTime}
            onMouseUp={this.clearMousePressTimeout}
          />
        </div>
      </div>
    );
  }

  setDeactivateBoundTimeout() {
    window.clearTimeout(this.deactivateBoundTimeout);

    this.deactivateBoundTimeout = window.setTimeout(() => {
      this.props.updateSelectedTrimBoundCreator(null);
    }, TRIM_BOUND_DEACTIVATE_TIMEOUT);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.active !== this.props.active) {
      return window.clearTimeout(this.deactivateBoundTimeout);
    }

    // this can happen with up/down hotkeys on the trim flags
    if (nextProps.active && nextProps.time !== this.props.time) {
      return this.setDeactivateBoundTimeout();
    }
  }

  async stepTime(step, stepFunction) {
    window.clearTimeout(this.mousePressKickInTimeout);
    window.clearTimeout(this.mousePressTimeout);

    const { half, min, time } = this.props;
    const newTime = Math.round(Math.max(min, time + step));

    this.props.onTimeChange(half, newTime);

    const { mouse_pressed: mousePressed } = this.state;

    // if this is the initiating mouse press, give it some time before kicking in
    if (!mousePressed) {
      await new Promise(resolve => {
        this.mousePressKickInTimeout = window.setTimeout(
          resolve,
          MOUSE_PRESS_KICK_IN_TIME
        );
      });

      if (this.state.mouse_pressed) {
        return;
      }

      this.setState({ mouse_pressed: true });
    }

    this.mousePressTimeout = window.setTimeout(
      stepFunction,
      MOUSE_PRESS_TIMEOUT
    );
  }

  decrementTime = () => {
    this.stepTime(-1 * PILL_TIME_STEP, this.decrementTime);
  };

  incrementTime = () => {
    this.stepTime(PILL_TIME_STEP, this.incrementTime);
  };

  activateTrimBound = async () => {
    const { time } = this.props;

    window.clearTimeout(this.deactivateBoundTimeout);

    const bound =
      this.props.half === LEFT_HALF ? TRIM_BOUND_LOWER : TRIM_BOUND_UPPER;

    // we have to await so the props update before setting the timeout since
    // `componentWillReceiveProps` will clear the timeout pre-emptively otherwise
    await this.props.updateSelectedTrimBoundCreator(bound);

    if (time === this.props.time) {
      this.setDeactivateBoundTimeout();
    }
  };

  clearMousePressTimeout = () => {
    window.clearTimeout(this.mousePressKickInTimeout);
    window.clearTimeout(this.mousePressTimeout);
    this.setState({ mouse_pressed: false });
  };
}

export default TrimPill;
